import { render, staticRenderFns } from "./RegisterSwFrame.vue?vue&type=template&id=12b5b3e3&scoped=true"
import script from "./RegisterSwFrame.vue?vue&type=script&lang=js"
export * from "./RegisterSwFrame.vue?vue&type=script&lang=js"
import style0 from "./RegisterSwFrame.vue?vue&type=style&index=0&id=12b5b3e3&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b5b3e3",
  null
  
)

export default component.exports